// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";

// LPWithdrawInit starts an LP withdraw. CKB path: lpCellID (outpoint of the
// cell), ckbOut (shannons), ownerAddress (full bech32m). ETH path: sharesToBurn.
// hub mirrors GetQuote's hub id for post-action notification.
@jsonObject()
export default class LPWithdrawInit extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;
  @jsonMember(String, { isRequired: false }) lpCellID?: string;
  @jsonMember(String, { isRequired: false }) ckbOut?: string;
  @jsonMember(String, { isRequired: false }) ownerAddress?: string;
  @jsonMember(String, { isRequired: false }) sharesToBurn?: string;
  @jsonMember(String) hub: string;

  constructor(
    asset: ChannelAsset,
    hub: string,
    opts: {
      lpCellID?: string;
      ckbOut?: string;
      ownerAddress?: string;
      sharesToBurn?: string;
    } = {},
  ) {
    super();
    this.asset = asset;
    this.hub = hub;
    this.lpCellID = opts.lpCellID;
    this.ckbOut = opts.ckbOut;
    this.ownerAddress = opts.ownerAddress;
    this.sharesToBurn = opts.sharesToBurn;
  }

  messageType(): MessageType {
    return LPWithdrawInit;
  }

  messageTypeName(): MessageTypeName {
    return "LPWithdrawInit";
  }
}
